import { RequestType } from 'models/enums/index';

export const getImage = (nameOfTask?: string) => {
  switch (nameOfTask) {
    case RequestType.Repair:
    case RequestType.Group:
      return '/pro-services/repair.svg';
    case RequestType.Addition:
      return '/pro-services/addition.svg';
    case RequestType.Upgrade:
      return '/pro-services/upgrade.svg';
    case RequestType.Preventative:
      return '/pro-services/preventative.svg';
    case RequestType.Recondition:
      return '/pro-services/reconditioning.svg';
    case RequestType.PickupAndDelivery:
      return '/pro-services/pickup.svg';
    case RequestType.HaulingAndStorage:
      return '/pro-services/hauling.svg';
    case RequestType.Cleaning:
      return '/pro-services/cleaning.svg';
    case RequestType.Inspection:
      return '/pro-services/inspections.svg';
    case RequestType.KeysAndAccess:
      return '/pro-services/keys.svg';
    case RequestType.Photography:
      return '/pro-services/photography.svg';
    case RequestType.Investigation:
      return '/pro-services/investigation.svg';
    case 'Recurring':
    default:
      return '/pro-services/legacy.svg';
  }
};

export const getStringFromTime = (repeatDays: number) => {
  if (repeatDays === 365) {
    return 'Yearly';
  } else if (repeatDays === 90) {
    return 'Quarterly';
  } else if (repeatDays === 30) {
    return 'Monthly';
  } else if (repeatDays > 0) {
    return `Every ${repeatDays} Days`;
  }
};
